import { forwardRef, useCallback } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { SnackbarContent, useSnackbar } from 'notistack';

const BasicSuccessAlert = forwardRef(({ id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const handleDismiss = useCallback(() => {
        closeSnackbar(id);
    }, [id, closeSnackbar]);

    return (
        <SnackbarContent ref={ref}>
            <Alert severity="success" onClose={handleDismiss}>
                <AlertTitle>¡Exito!</AlertTitle>
                {props.message}
            </Alert>
        </SnackbarContent>
    );
});

export default BasicSuccessAlert;
